import React from 'react'

const style = {
    position: 'fixed',
    bottom: 0,
    backgroundColor: 'white',
    width: '100%',
    marginLeft: '-24px',
    padding: '15px 24px',
    borderTop: '1px solid lightgrey', 
}

const StickyFooter = (props) => {
    return (
        <div style={style}>
            {props.children}
        </div>
    )
}

export default StickyFooter